import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useSupabaseClient } from 'src/api/supabase'
import { Database } from 'supabase/database.types'

import { queryKeys } from './queryKeys'

export type InsertMessage = Database['public']['Tables']['message']['Insert']
export type Message_ = Database['public']['Tables']['message']['Row']

export const useMessageApi = () => {
  const queryClient = useQueryClient()
  const supabase = useSupabaseClient()

  const { data: messages } = useQuery({
    queryKey: [queryKeys.messages],
    queryFn: async () =>
      await supabase
        .from('message')
        .select('*')
        .order('created_at', { ascending: false }),
  })

  const createMessage = useMutation({
    mutationFn: async (insertMessage: InsertMessage) =>
      await supabase
        .from('message')
        .insert(insertMessage)
        .select('*')
        .single(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.chats] })
    },
  })

  const updateMessage = useMutation({
    mutationFn: async (insertMessage: InsertMessage) =>
      await supabase
        .from('message')
        .update(insertMessage)
        .eq('id', insertMessage.id!),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.chats] })
    },
  })

  const deleteMessage = useMutation({
    mutationFn: async (id: number) =>
      await supabase.from('message').delete().eq('id', id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKeys.chats] })
    },
  })

  return {
    messages,
    createMessage,
    updateMessage,
    deleteMessage,
  }
}
